// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KwR1","comment":"styles_comment__TfhtV"};